import { makeStyles } from "@material-ui/core/styles";

export const InvoiceHomeCss = makeStyles(theme => ({

    pageContentDiv: {
        padding: 24,
        backgroundColor: 'white',
        height: 'calc(100vh - 115px)',
        overflow: 'auto'
    },
    thTruckRightAlign: {
        backgroundColor: '#E3E8FD',
        border: '1px solid #dfe2e5',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'end',
        paddingLeft: 16,
        paddingRight: 16,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    thTruckRightAlignV1: {
        backgroundColor: '#E3E8FD',
        border: '1px solid #dfe2e5',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'end',
        paddingLeft: 16,
        paddingRight: 50,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    invoiceAmount: {
        textAlign: 'right',
        fontWeight: 600,
        width: '100%',
    },
    balanceAmount: {
        textAlign: 'right',
        fontWeight: 600,
        width: '100%'
    },
    balanceAmountGrey: {
        textAlign: 'right',
        fontWeight: 600,
        width: '100%',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    rightIcon: {
        color: 'grey',
        marginLeft: '12px'
    },
    divInvoiceStatus: {
        color: '#9ea0a5',
        fontSize: 13,
        // textAlign: 'end',
        marginTop: '-20px',
        marginBottom: '4px',
        textAlign: 'start'
    },
    divFilter: {
        textAlign: 'right !important',
        marginLeft: '-5em'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
    },
    dueStatusOverdue: {
        fontWeight: 'normal',
        color: '#ff0000'
    },
    dueStatusPaid: {
        fontWeight: 'normal',
        color: '#079627'
    },
    dueStatus: {
        fontWeight: 'normal',
    },
    highlight: {
        color: '#1860f0',
        backgroundColor: 'transparent !important',
        padding: '0px !important'
    },
    titlePreview: {
        fontSize: '24px',
        fontWeight: 'normal',
        color: '#0b1323'
    },
    fwNormal: {
        fontWeight: 'normal'
    },
    divEmpty: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 25,
        marginLeft: '-12px'
    },
    imgV2: {
        marginLeft: 36,
        width: 429,
        height: 606
    },
    imgV1: {
        width: 429,
        height: 606
    }

}));

export const SingleInvoiceCss = makeStyles(() => ({

    titleV1: {
        fontSize: '18px',
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    divContainer: {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 9
    },
    mtV1: {
        marginTop: 16
    },
    titleV2: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#0b1323'
    },
    editButton: {
        padding: '2px 12px',
        borderRadius: '4px',
        border: 'solid 1px #0033cc',
        textTransform: 'uppercase',
        color: '#0033cc',
        fontWeight: 600
    },
    divAlign: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 24
    },
    divWidth: {
        width: '70%'
    },
    fwNormal: {
        fontWeight: 'normal'
    },
    mtV2: {
        marginTop: 8
    },
    divAlignV1: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600
    },
    changeButton: {
        padding: '2px 8px',
        borderRadius: '4px',
        border: 'solid 1px #0033cc',
        textTransform: 'uppercase',
        color: '#0033cc',
        fontWeight: 600
    },
    gridV1: {
        backgroundColor: 'white',
        marginTop: 8,
        borderRadius: 8,
        minHeight: '180px'
    },
    gridV3: {
        backgroundColor: 'white',
        marginTop: 8,
        borderRadius: 8,
        height: '100%'
    },
    divOuterBox: {
        backgroundColor: 'rgba(11, 19, 35, 0.15)',
        width: '100%',
        height: '100%',
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 48,
        paddingBottom: 48
    },
    gridContainerV3: {
        width: 150,
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8
    },
    divInnerBox: {
        backgroundColor: 'white',
        width: '84px',
        height: '84px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        outline: '4px dashed white'
    },
    pdV1: {
        paddingLeft: 16,
        paddingRight: 16
    },
    pdV2: {
        paddingTop: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 12
    },
    pdV3: {
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16,
        paddingBottom: 24
    },
    mtV3: {
        marginTop: 16
    },
    dividerRoot: {
        backgroundColor: 'rgba(172, 172, 172, 0.25) !important'
    },
    paddingStart: {
        paddingLeft: 6
    },
    paddingStartV1: {
        paddingLeft: 1
    },
    textV1: {
        overflowWrap: 'anywhere',
        fontWeight: 600,
        marginTop: 2
    },
    titleV3: {
        fontSize: '12px',
        color: 'rgba(11, 19, 35, 0.7)'
    },
    divWidthV1: {
        width: "30%",
        marginLeft: 24,
        display: 'flex',
        flexDirection: 'column'
    },
    divAlignV2: {
        display: 'flex',
        marginTop: 24,
        marginBottom: 52
    },
    divWidthV2: {
        width: "33%"
    },
    divWidthV3: {
        width: "33%",
        marginLeft: 24
    },
    divWidthV4: {
        width: "33%",
        marginLeft: 24
    },
    mtV4: {
        marginTop: 24
    },
    addGSTSection: {
        marginTop: 12,
        padding: 16,
        backgroundColor: '#fff',
        borderRadius: 8
    },
    addGSTButton: {
        backgroundColor: '#f1f3f6',
        borderRadius: 8,
        paddingTop: 20,
        paddingBottom: 20,
        color: '#0033cc',
        fontWeight: 600
    },
    addGSTInfo: {
        display: 'flex',
        padding: "8px 12px 8px 16px",
        backgroundColor: "#f1f3f6",
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    gstPercentage: {
        padding: 8,
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '14px !important',
        paddingLeft: 16,
        paddingRight: 12
    },
    gstPercentageV1: {
        padding: 8,
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '14px !important',
        paddingLeft: 16,
        paddingRight: 12,
        backgroundColor: '#f1f3f6'
    },
    gstRC: {
        fontWeight: 600,
        fontSize: 14
    },
    moreDetailsContainer: {
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 16,
        marginTop: 8
    },
    termsContainer: {
        backgroundColor: '#f1f3f6',
        height: '128px',
        borderRadius: 8,
        padding: 16,
        paddingBottom: 24
    },
    textV2: {
        color: '#0b1323',
        fontSize: 16,
        fontWeight: 600
    },
    signatureContainer: {
        marginTop: 16,
        backgroundColor: '#f1f3f6',
        minHeight: '115px',
        borderRadius: 8,
        padding: 16,
        paddingBottom: 8
    },
    signatureContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginTop: 7
    },
    divAlignV3: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    titleV4: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#00875a'
    },
    gridV2: {
        backgroundColor: 'white',
        marginTop: 8,
        borderRadius: 8,
        border: 'solid 2px #00875a',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 24,
        paddingBottom: 24
    },
    invoiceAmountContainer: {
        padding: '8px 48px 8px 16px',
        borderRadius: 4,
        backgroundColor: '#f1f3f6'
    },
    paymentsReceivedContainer: {
        padding: '8px 48px 8px 16px',
        borderRadius: 4,
        backgroundColor: '#edfaf3',
        marginTop: 16
    },
    fw600: {
        fontWeight: 600
    },
    balanceAmountContainer: {
        padding: '8px 48px 8px 16px',
        borderRadius: 4,
        backgroundColor: '#faf3f3'
    },
    hrV1: {
        borderTop: '1px dashed #acacac',
        marginTop: 12,
        marginBottom: 12
    },
    boxShadow: {
        boxShadow: 'none !important',
        backgroundColor: '#edfaf3',
        borderRadius: "4px !important"
    },
    divAlignV4: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100% !important'
    },
    gridItemV1: {
        width: '100%',
        marginTop: 16
    },
    accordionContent: {
        marginBottom: '8px !important',
        marginTop: '8px !important'
    },
    iconButtonAccordion: {
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingLeft: '16px !important',
        paddingRight: '8px !important'
    },
    accordionSummaryRoot: {
        minHeight: 'unset !important'
    },
    divTable: {
        '& .MuiTableRow-root': {
            cursor: 'default',
        },
        '& div': {
            marginBottom: '0px !important'
        },
        marginTop: 8
    },
    editIcon: {
        color: '#0033cc',
        fontSize: 16
    },
    editIconButton: {
        border: '1px solid #0033cc',
        borderRadius: 4,
        width: 26,
        height: 26
    },
    mlV1: {
        marginLeft: 12
    },
    divAlignV5: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    thTruckRightAlign: {
        backgroundColor: '#E3E8FD',
        border: '1px solid #dfe2e5',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'end',
        paddingLeft: 16,
        paddingRight: 16,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    thTruckRightAlignV1: {
        backgroundColor: '#E3E8FD',
        border: '1px solid #dfe2e5',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'end',
        paddingLeft: 16,
        paddingRight: 52,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    textV3: {
        fontWeight: 'normal',
        textAlign: 'right',
        width: '100%'
    },
    divButtonContainer: {
        width: '100%'
    },
    divButtonContainerV1: {
        width: '100%',
        marginTop: 24
    },
    addTermsButton: {
        borderRadius: 8,
        backgroundColor: '#f1f3f6',
        height: '128px',
        width: '100%',
        textTransform: 'none',
        color: '#0033cc',
        fontWeight: 600,
        fontSize: 16
    },
    addSignatureButton: {
        borderRadius: 8,
        backgroundColor: '#f1f3f6',
        height: '115px',
        marginTop: 16,
        width: '100%',
        textTransform: 'none',
        color: '#0033cc',
        fontWeight: 600,
        fontSize: 16
    },
    termsContent: {
        fontStyle: 'italic',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    termsContainerV1: {
        backgroundColor: '#f1f3f6',
        height: '128px',
        borderRadius: 8,
        padding: 16,
        paddingBottom: 24,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontStyle: 'italic',
        color: '#8e8e8e',
        fontSize: 16
    },
    imgV1: {
        width: 120,
        height: 60
    },
    verifiedText: {
        color: '#73b27d',
        marginLeft: 8
    },
    checkboxText: {
        fontSize: 14
    },
    mtV5: {
        marginTop: 26
    },
    deleteIcon: {
        color: '#ff0000',
        fontSize: 14
    },
    divAlignV6: {
        display: 'flex',
        alignItems: 'center',
    },
    divAlignV7: {
        display: 'flex',
        alignItems: 'center'
    },
    textV4: {
        fontSize: 12
    },
    dotV1: {
        color: '#768186',
        fontSize: 6,
        marginLeft: 4,
        marginRight: 4
    },
    textV5: {
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    deleteIconButton: {
        padding: 6,
        marginLeft: 10,
        marginTop: -2
    },
    widthV1: {
        width: '100%'
    },
    divAlignV8: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100% !important',
        marginTop: 4,
        marginLeft: 4,
        paddingRight: 40
    },
    divAlignV9: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100% !important',
        marginLeft: 4,
        paddingRight: 40
    },
    divAlignV10: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '16px'
    },
    addBankButton: {
        textTransform: 'none',
        borderRadius: 4,
        color: '#0033cc',
        border: '1px solid lightgrey',
        fontSize: 14,
        fontWeight: 600
    },
    gridWidthV1: {
        maxWidth: '55%',
        flexBasis: '55%'
    },
    gridWidthV2: {
        maxWidth: '28.4%',
        flexBasis: '28.4%'
    },
    gridWidthV3: {
        maxWidth: '64.333333%',
        flexBasis: '64.333333%'
    },
    imgV2: {
        width: '84px',
        height: '84px',
        borderRadius: '8px !important'
    },
    gridContainerV4: {
        height: '180px'
    },
    endPadding: {
        paddingRight: 6
    },
    gstAmount: {
        fontSize: '14px !important',
        fontWeight: 600
    },
    fs14: {
        fontSize: '14px !important'
    },
    signatureText: {
        fontSize: '14px',
        fontWeight: 300
    },
    switchTrack: {
        height: '10px',
        width: '21px',
        marginLeft: '5px'
    },
    switchThumb: {
        width: '16px',
        height: '16px'
    },
    mt5: {
        marginTop: '5px'
    }

}));
